import React, { useEffect, useRef, useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import image from '../../assets/image.png';
import senddata from "../../Data/data.js";
import sendFormData from "../../Data/formData.js";

function News() {
    const [file,setFile]=useState("");
    const [selectedImage,setSelectedImage]=useState("");
    const [newsList,setNewsList]=useState([]);

    // 25/7
    const [youtubeLink, setYoutubeLink] = useState("");
    const [reals, setReals] = useState([]);

    // 25/8
    const [enableEdit, setEnableEdit] = useState(false);
    const [form, setForm] = useState({
      FirstName: "",
      LastName: "",
      email: "",
      mobile: "",
      photo: ""
    });

  const fileInputRef = useRef(null);

  useEffect(()=>{
    getAllNews();
    getAllReals();
    // 25/8
    fetchTeacherData();
  },[])

  const handleFileChange = (e) => {
    const newfile = e.target.files[0];
    if (newfile) {
        const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
        if (!validImageTypes.includes(newfile.type)) {
          alert("ادخل صورة ")
          return;
      }
        setFile(newfile)
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result); 
        };
        reader.readAsDataURL(newfile); 
    }else {
      setSelectedImage(""); 
      setFile("");
    }
  };

  const addNews = () =>{
    console.log(file)
    let data = new FormData();
    data.append('file',file );
    if (newsList.length>3){
        alert("يرجي مسح خبر اولا ... اقصي عدد هو 4 ")
        return
    }
    if (!file){
        alert("يرجي اضافة صورة ")
        return
    }
    sendFormData("image/add_image",data, "POST").then((res) => {
        if (res.status !== 200) {
            alert('تأكد من الاتصال من الانترنت ');
        } else {
            alert('تم اضافة الصورة بنجاح ');
            getAllNews();
        }
        });
  }

  const getAllNews = () =>{
    senddata("image/get_all_images",{}, "GET").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
        } else {
            setNewsList(res.data);
            console.log(res.data)
        }
        });
  }

  const deletenews = (id) =>{
    // confirm
    const userResponse = prompt(`امتب Ok لتأكيد حذف الحالة `);
    // delete
    if(userResponse?.trim() =="ok" ){
      senddata(`image/delete_image/${id}`,{}, "DELETE").then((res) => {
        if (res.status !== 200) {
          alert('تأكد من الاتصال بالانترنت');
        } else {
          alert('تم حذف الحالة  ');
          getAllNews();
        }
        });
    }else{
      alert("لم يتم حذف الطالب")
    }
  }

  // 25/7
  const getAllReals = () => {
    senddata("reals/get_all_reals", {}, "GET").then((res) => {
      if (res?.status !== 200) {
        alert("تأكد من الاتصال بالانترنت");
      } else {
        setReals(res.data);
      }
    });
  };

  const addReal = () => {
    if (!youtubeLink) {
      alert("يرجى إدخال رابط فيديو من YouTube");
      return;
    }
    if (reals.length >= 5) {
      alert("الحد الأقصى هو 5 فيديوهات. قم بالحذف أولاً.");
      return;
    }
    console.log(youtubeLink)
    senddata("reals/add_real", { videoPath: youtubeLink }, "POST").then((res) => {
      if (res.status !== 200) {
        alert("حدث خطأ، تأكد من صحة الرابط");
      } else {
        alert("تم إضافة الريل بنجاح");
        setYoutubeLink("");
        getAllReals();
      }
    });
  };

  const deleteReal = (id) => {
    const confirm = prompt("اكتب ok لحذف الفيديو");
    if (confirm?.trim() === "ok") {
      senddata(`reals/delete_real/${id}`, {}, "DELETE").then((res) => {
        if (res.status !== 200) {
          alert("فشل في حذف الفيديو");
        } else {
          alert("تم الحذف بنجاح");
          getAllReals();
        }
      });
    }
  };

  // 25/8
  const fetchTeacherData = async () => {
    try {
      const res = await senddata(`teacher/getuser`, {}, "GET");
      if (res.status === 200) {
        setForm({
          FirstName: res.data.FirstName || "",
          LastName: res.data.LastName || "",
          mobile: res.data.mobile || "",
          photo: res.data.photo || "",
        });
      } else {
        alert("فشل في جلب البيانات");
      }
    } catch (err) {
      alert("خطأ في الاتصال بالسيرفر");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };


  const saveInfo = async () => {
    try {
      const res = await senddata(`teacher/edit`, form, "PUT");
      if (res.status === 200) {
        alert("تم تحديث بيانات المعلم بنجاح");
        fetchTeacherData();
        setEnableEdit(false);
      } else {
        alert("حدث خطأ أثناء التحديث");
      }
    } catch (err) {
      alert("خطأ في الاتصال أثناء التحديث");
    }
  };

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
        <div className='headers  '>
            <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
        </div>

          <div>
            <div className=' grid grid-cols-1 rever gap-4'>
              <img src={selectedImage} className='w-full mb-4 lg:w-[60%] lg:ml-[20%]' />
            </div>
            <div className=' grid grid-cols-2 rever gap-4'>
              <p onClick={addNews} className='px-6 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6'>اضافة خبر</p> 
              <div className='h-full flex items-end justify-end' >
                <p onClick={()=>{setFile("");setSelectedImage("");}} className='mr-4 text-2xl cursor-pointer'>🗑️</p>
                <img src={image} className='w-12 rounded-full mt-auto lg:mr-5 cursor-pointer' onClick={()=>{fileInputRef.current.click()}} />
              </div>
              <input 
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                />
            </div>
          </div>

          <div>
            <h2 className='border-b-2 border-[#e9ad03] w-fit center ml-auto mr-auto mt-[40px] mb-10'> الاخبار</h2>
            {newsList.length&&
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[90%] ml-[5%] '>
                    {
                        newsList?.map((news,key)=>{
                            return(
                            <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                                {news.imageUrl!="empty" && <div className=' grid grid-cols-1 rever gap-4'>
                                <img src={news.imageUrl} className='w-full mb-4 ' />
                                {/* offline */}
                                {/* <img src={"https://c8.alamy.com/comp/EWGXMK/rubber-stamp-with-text-exam-results-inside-illustration-EWGXMK.jpg"} className='w-full mb-4 ' /> */}
                                </div>}
                                <div className='flex '>
                                    <p onClick={()=>{deletenews(news._id)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                                </div>
                            </div>
                            )
                        })
                    }
                </div>
            }
          </div>

          <div className="w-[90%] ml-[5%] mt-10">
        <input
          type="text"
          value={youtubeLink}
          onChange={(e) => setYoutubeLink(e.target.value)}
          placeholder="ضع رابط يوتيوب هنا"
          className="w-full p-3 rounded-lg text-black"
        />
        <button
          onClick={addReal}
          className="mt-4 px-6 py-2 bg-[#da0000] rounded-full"
        >
          إضافة فيديو
        </button>
      </div>

      <h2 className="border-b-2 border-[#e9ad03] w-fit center ml-auto mr-auto mt-[40px] mb-10">
        الفيديوهات
      </h2>

      {reals.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 w-[90%] ml-[5%]">
          {reals?.map((real, key) => (
            <div key={key} className="mb-10 border-2 border-[#e9ad03] rounded-xl p-2">
              <div className="aspect-w-16 aspect-h-9">
                <iframe
                  className="w-full h-[200px] rounded"
                  src={real?.realUrl}
                  title={`ريل ${key}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="flex mt-2">
                <p
                  onClick={() => deleteReal(real?._id)}
                  className="mr-4 text-lg cursor-pointer"
                >
                  🗑️
                </p>
              </div>
            </div>
          ))}
        </div>
      )}



      {/* 25/8 */}
      <div className="flex flex-col items-center text-white bg-[#1A1A4C] min-h-screen pt-10 pb-20">
        <h2 className="border-b-2 border-[#e9ad03] text-xl">تفاصيل المعلم</h2>

        <div className="flex flex-row justify-between w-[60%] mt-6">
          {enableEdit ? (
            <input
              name="FirstName"
              className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none text-end"
              value={form.FirstName}
              onChange={handleChange}
            />
          ) : (
            <p>{form.FirstName}</p>
          )}
          <p>: الاسم الأول</p>
        </div>

        <div className="flex flex-row justify-between w-[60%] mt-2">
          {enableEdit ? (
            <input
              name="LastName"
              className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none text-end"
              value={form.LastName}
              onChange={handleChange}
            />
          ) : (
            <p>{form.LastName}</p>
          )}
          <p>: اسم العائلة</p>
        </div>

        <div className="flex flex-row justify-between w-[60%] mt-2">
          {enableEdit ? (
            <input
              name="mobile"
              className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none text-end"
              value={form.mobile}
              onChange={handleChange}
            />
          ) : (
            <p>{form.mobile}</p>
          )}
          <p>: رقم الهاتف</p>
        </div>

        <div className="flex flex-row justify-between w-[60%] mt-2">
          {enableEdit ? (
            <input
              name="photo"
              className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none text-end"
              value={form.photo}
              onChange={handleChange}
            />
          ) : (
            <p>{form.photo}</p>
          )}
          <p>: رابط الصورة</p>
        </div>

        {form.photo && (
          <div className="w-[60%] mt-4 text-center">
            <img src={form.photo} alt="Teacher" className="rounded w-[150px] mx-auto border" />
          </div>
        )}

        <div className="grid grid-cols-2 gap-2 w-[70%] ml-auto mr-auto mt-10">
          {enableEdit ? (
            <p
              onClick={saveInfo}
              className="px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer mr-auto"
            >
              حفظ
            </p>
          ) : (
            <p></p>
          )}
          <p
            onClick={() => setEnableEdit(!enableEdit)}
            className="px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto"
          >
            {enableEdit ? "عدم التعديل" : "تعديل"}
          </p>
        </div>
      </div>



      
    </div>
  )
}

export default News
